import { Accept, FromBody, FromRoute, HttpStatusCodes, Inject, Result } from '@resourceful-hono/core';
import { Permissions } from '../../../services/OAuth/enums.ts';
import { BaseResource } from '../BaseResource.ts';
import { Protected } from '../common/decorators.ts';
import { GET_SCHEMA, POST_SCHEMA } from './schema.ts';
import { z } from 'zod';
import { CustomContentTypes } from '../../../common/enums.ts';
import { ImageStorageService } from '../../../services/ImageStorageService.ts';

export class AvatarResource extends BaseResource {
  @Inject()
  declare protected imageStorage: ImageStorageService;

  public async GET(
    @FromRoute(GET_SCHEMA) route: z.infer<typeof GET_SCHEMA>
  ) {
    const { data, contentType } = await this.imageStorage.get(route.filename);

    return Result(HttpStatusCodes.Ok, data, contentType);
  }

  @Accept([CustomContentTypes.Cbor])
  @Protected([Permissions.PatchUser])
  public async POST(
    @FromBody(POST_SCHEMA) body: z.infer<typeof POST_SCHEMA>
  ) {
    const { signal } = this.request;
    const { data, type } = body;
    const id = await this.imageStorage.put(new Blob([data], { type }), signal);
    const url = `${AvatarResource.pathname}/${id}`;

    const user = await this.user;
    user.avatar = url;
    await user.save();

    return Result(HttpStatusCodes.Created);
  }
}